import { lazy, Suspense } from 'react';
import { RouteObject } from 'react-router';
import { Spin } from 'antd';
import { ProtectedRoutes } from '@/router/ProtectedRoutes.tsx';

const FundDashboardPage = lazy(() => import('./fund-dashboard-page.tsx'));
const FundDetailPage = lazy(() => import('./fund-detail-page.tsx'));
const FundDashboardAnalyticsView = lazy(() =>
  import('./fund-dashboard-page.tsx').then(({ FundDashboardView }) => ({
    default: FundDashboardView,
  })),
);

/** The Funds tab body under the Analytics shell; the shell owns the permission guard. */
export const fundDashboardAnalyticsRoute: RouteObject = {
  path: 'funds',
  element: (
    <Suspense fallback={<Spin />}>
      <FundDashboardAnalyticsView />
    </Suspense>
  ),
};

export const fundManagementRoutes: RouteObject = {
  path: 'fund-management',
  element: (
    <ProtectedRoutes
      requiredPermissions={[
        { moduleName: 'investor-management', functionName: 'read-investor-profile' },
      ]}
    />
  ),
  children: [
    {
      path: 'dashboard',
      element: (
        <Suspense fallback={<Spin />}>
          <FundDashboardPage />
        </Suspense>
      ),
    },
    {
      path: 'fund/:fundId',
      element: (
        <Suspense fallback={<Spin />}>
          <FundDetailPage />
        </Suspense>
      ),
    },
  ],
};
